import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import LinkButton from './LinkButton';
import { BodyLG } from './TextTypes';

const ScreeningParametersInfoSliderPageHeading = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <TitleWrapper>{t('components.so-what-exactly-we-test-for-sti')}</TitleWrapper>
      <TextButtonWrapper>
        <BodyLG>{t('components.so-what-exactly-we-test-for-sti-desc')}</BodyLG>
        <ButtonWrapper>
          <LinkButton to={'/products/at-home-sti-screening/'}>{t('components.screen-now')}</LinkButton>
        </ButtonWrapper>
      </TextButtonWrapper>
    </Wrapper>
  );
};

export default ScreeningParametersInfoSliderPageHeading;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  span {
    text-align: left;
    display: block;
    max-width: 890px;

    @media (max-width: 768px) {
      padding: 0 10px 0 10px;
      text-align: center;
    }
  }

  @media (max-width: 768px) {
    gap: 20px;
    margin-bottom: -10px;
  }
`;

const TextButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    gap: 20px;
    flex-direction: column-reverse;
  }
`;

const ButtonWrapper = styled.div`
  a {
    display: inline-flex;
    justify-self: center;
  }

  @media (max-width: 768px) {
    align-self: center;
  }
`;

const TitleWrapper = styled.div`
  color: ${Colors.navyBlue};
  font-family: Domaine;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 48px */
  letter-spacing: -0.4px;

  @media (max-width: 768px) {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 28.8px */
    letter-spacing: -0.24px;
    text-align: center;
    max-width: 225px;
    align-self: center;
  }
`;
